import axios from 'axios';
import { toast } from 'react-toastify';
import AuthService from './store/services/authService';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message?.toLowerCase() || '';
    const errorText = error?.response?.data?.error?.toLowerCase() || '';

    // Check if this is an authentication-related error
    const isAuthError =
      status === 401 ||
      ((status === 500 || status === 400) &&
        (message.includes('token') ||
          message.includes('token not found') ||
          message.includes('token not found') ||
          message.includes('invalid token') ||
          message.includes('token expired') ||
          message.includes('user does not exist') ||
          message.includes('user not found') ||
          errorText.includes('user does not exist') ||
          errorText.includes('user not found')));

    // Handle authentication errors - clear cookies, localStorage (including persist:root), and reload
    if (isAuthError) {
      console.log(
        `🔐 Authentication error (${status}): ${error?.response?.data?.message || 'Auth failed'}. Clearing auth data...`
      );

      // Clear all authentication data (including persist:root from localStorage)
      AuthService.clearAuth();

      // Show error message and reload
      toast.error('Session expired. Redirecting to login...');

      // Small delay before reload to show the toast and ensure storage is cleared
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

    return Promise.reject(error);
  }
);

export default api;
